module.exports = __webpack_public_path__ + "static/media/why_end.489b3ea4.jpg";